/*  ========================================================================
    # Hooks - Use Get Params
    ========================================================================  */

export default function useGetParams() {
  return Object.fromEntries(new URLSearchParams(window.location.search));
}
